import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import DefaultApiKeysPage from './Pages/DefaultApiKeysPage';
import WizardPage from './Pages/WizardPage';

const ApiKeysRouter = () => {
    let { path } = useRouteMatch();

    return (
        <Switch>
            <Route path={`${path}/wizard`}>
                <WizardPage />
            </Route>
            <Route path={`${path}/:keySid/wizard`}>
                <WizardPage />
            </Route>
            <Route default>
                <DefaultApiKeysPage />
            </Route>
        </Switch>
    );
};

export default ApiKeysRouter;
